import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { RestResponse } from './core.model';
import { Observable, of } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class SessionService {
    constructor(private http: Http) { }

    public isSessionActive() {
        return this.postIsSessionActive();
    }

    private createHeaders(headers: Headers) {
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', 'bearer ' + localStorage.getItem('token'));
        headers.append('RefreshToken', localStorage.getItem('refreshToken'));
    }

    private postIsSessionActive(): Observable<boolean> {
        const path = '/api/auth/isSessionActive';
        const headers = new Headers();
        this.createHeaders(headers);
        
        return this.http.post(path, undefined, { headers: headers })
            .map((res: Response) => {
                if (res.status === 401 || res.status === 403) {
                    throw new Error();
                }
                const restResponse: RestResponse<boolean> = res.json();
                if (restResponse.data == true) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch((error) => {
                return of(false);
            });
    }
}